export const pages = [
  { id: "about", text: "About", path: "/" },
  {
    id: "sdgsProjects",
    text: "SDGs & Projects",
    path: "/resources?pagename=sdgsProjects&type=content",
  },
  {
    id: "courses",
    text: "Courses",
    path: "/resources?pagename=courses&type=content",
  },
  {
    id: "activities",
    text: "Activities",
    path: "/resources?pagename=activities&type=content",
  },
  {
    id: "conferences",
    text: "Conferences",
    path: "/resources?pagename=conferences&type=content",
  },
  {
    id: "initiatives",
    text: "Initiatives",
    path: "/resources?pagename=initiatives&type=content",
  },
  {
    id: "publications",
    text: "Publications",
    path: "/resources?pagename=publications&type=content",
  },
  {
    id: "contacts",
    text: "Contact Us",
    path: "/resources?pagename=contacts&type=support",
  },
  {
    id: "donates",
    text: "Donates",
    path: "/resources?pagename=donates&type=support",
  },
];
